var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSchedulePipelineGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 2,
    fill: "#E7E6FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9167 11.8333C13.6656 11.8333 11.8333 13.665 11.8333 15.9167C11.8333 18.1683 13.6656 20 15.9167 20C18.1677 20 20 18.1683 20 15.9167C20 13.665 18.1677 11.8333 15.9167 11.8333ZM15.9167 18.8333C14.3084 18.8333 13 17.5249 13 15.9167C13 14.3084 14.3084 13 15.9167 13C17.5249 13 18.8333 14.3084 18.8333 15.9167C18.8333 17.5249 17.5249 18.8333 15.9167 18.8333ZM16.5 15.6752L17.4958 16.6709L16.6709 17.4958L15.3333 16.1582V14.1667H16.5V15.6752ZM20 8.91667V12.6202C19.6681 12.2096 19.2726 11.8549 18.8333 11.5598V8.91667C18.8333 8.59525 18.572 8.33333 18.25 8.33333H7.75C7.42858 8.33333 7.16667 8.59525 7.16667 8.91667V10.6667H15.9167C14.6672 10.6667 13.5215 11.1047 12.6202 11.8333H7.16667V18.8333H11.5522C11.8473 19.2743 12.2084 19.6669 12.6202 20H6V8.91667C6 7.95183 6.78517 7.16667 7.75 7.16667H9.5V6H10.6667V7.16667H15.3333V6H16.5V7.16667H18.25C19.2148 7.16667 20 7.95183 20 8.91667Z",
    fill: "#4333F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedulePipelineGroup);
export default __webpack_public_path__ + "static/media/schedulePipelineGroup.ec15316b90ff706a1c474e6133369ce6.svg";
export { ForwardRef as ReactComponent };